// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_87J","cls2":"CreateSocialItemModal-cls2_7sm CreateSocialItemModal-cls1_87J"};